"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.characterUnicodeChart = {
    "leftrightsquigarrow": "↭",
    "Longleftrightarrow": "⟺",
    "blacktriangleright": "▶",
    "longleftrightarrow": "⟷",
    "blacktriangledown": "▼",
    "blacktriangleleft": "◀",
    "leftrightharpoons": "⇋",
    "rightleftharpoons": "⇌",
    "twoheadrightarrow": "↠",
    "circlearrowright": "↻",
    "downharpoonright": "⇂",
    "rightharpoondown": "⇁",
    "rightrightarrows": "⇉",
    "twoheadleftarrow": "↞",
    "vartriangleright": "⊳",
    "bigtriangledown": "▽",
    "circlearrowleft": "↺",
    "curvearrowright": "↷",
    "downharpoonleft": "⇃",
    "leftharpoondown": "↽",
    "leftrightarrows": "⇆",
    "rightleftarrows": "⇄",
    "rightsquigarrow": "⇝",
    "rightthreetimes": "⋌",
    "trianglerighteq": "⊵",
    "vartriangleleft": "⊲",
    "Leftrightarrow": "⇔",
    "Longrightarrow": "⟹",
    "curvearrowleft": "↶",
    "dashrightarrow": "⇢",
    "doublebarwedge": "⩞",
    "downdownarrows": "⇊",
    "hookrightarrow": "↪",
    "leftleftarrows": "⇇",
    "leftrightarrow": "↔",
    "leftthreetimes": "⋋",
    "longrightarrow": "⟶",
    "looparrowright": "↬",
    "rightarrowtail": "↣",
    "rightharpoonup": "⇀",
    "sphericalangle": "∢",
    "textregistered": "®",
    "trianglelefteq": "⊴",
    "upharpoonright": "↾",
    "Longleftarrow": "⟸",
    "bigtriangleup": "△",
    "blacktriangle": "▲",
    "dashleftarrow": "⇠",
    "divideontimes": "⋇",
    "fallingdotseq": "≒",
    "hookleftarrow": "↩",
    "leftarrowtail": "↢",
    "leftharpoonup": "↼",
    "longleftarrow": "⟵",
    "looparrowleft": "↫",
    "measuredangle": "∡",
    "shortparallel": "∥",
    "smallsetminus": "∖",
    "texttrademark": "™",
    "triangleright": "▷",
    "upharpoonleft": "↿",
    "blacklozenge": "◆",
    "risingdotseq": "≓",
    "triangledown": "▽",
    "triangleleft": "◁",
    "Rrightarrow": "⇛",
    "Updownarrow": "⇕",
    "backepsilon": "∍",
    "blacksquare": "■",
    "circledcirc": "⊚",
    "circleddash": "⊝",
    "curlyeqprec": "⋞",
    "curlyeqsucc": "⋟",
    "diamondsuit": "♢",
    "preccurlyeq": "≼",
    "succcurlyeq": "≽",
    "textgreater": ">",
    "thickapprox": "≈",
    "updownarrow": "↕",
    "vartriangle": "△",
    "Lleftarrow": "⇚",
    "Rightarrow": "⇒",
    "circledast": "⊛",
    "complement": "∁",
    "curlywedge": "⋏",
    "longmapsto": "⟼",
    "registered": "®",
    "rightarrow": "→",
    "smallfrown": "⌢",
    "smallsmile": "⌣",
    "sqsubseteq": "⊑",
    "sqsupseteq": "⊒",
    "textlangle": "〈",
    "textrangle": "〉",
    "upuparrows": "⇈",
    "varepsilon": "ε",
    "varnothing": "∅",
    "Downarrow": "⇓",
    "Leftarrow": "⇐",
    "backprime": "‵",
    "bigotimes": "⨂",
    "centerdot": "⋅",
    "copyright": "©",
    "downarrow": "↓",
    "gtreqless": "⋛",
    "heartsuit": "♡",
    "leftarrow": "←",
    "lesseqgtr": "⋚",
    "pitchfork": "⋔",
    "spadesuit": "♠",
    "therefore": "∴",
    "trademark": "™",
    "triangleq": "≜",
    "varpropto": "∝",
    "approxeq": "≊",
    "barwedge": "⊼",
    "bigoplus": "⨁",
    "bigsqcup": "⨆",
    "biguplus": "⨄",
    "bigwedge": "⋀",
    "boxminus": "⊟",
    "boxtimes": "⊠",
    "circledS": "Ⓢ",
    "clubsuit": "♣",
    "curlyvee": "⋎",
    "doteqdot": "≑",
    "emptyset": "∅",
    "intercal": "⊺",
    "leqslant": "⩽",
    "multimap": "⊸",
    "parallel": "∥",
    "setminus": "∖",
    "sqsubset": "⊏",
    "sqsupset": "⊐",
    "subseteq": "⊆",
    "supseteq": "⊇",
    "textless": "<",
    "thicksim": "∼",
    "triangle": "△",
    "varkappa": "ϰ",
    "varsigma": "ς",
    "vartheta": "ϑ",
    "Diamond": "◇",
    "Uparrow": "⇑",
    "Upsilon": "Υ",
    "backsim": "∽",
    "because": "∵",
    "between": "≬",
    "bigodot": "⨀",
    "bigstar": "★",
    "boxplus": "⊞",
    "ddagger": "‡",
    "diamond": "⋄",
    "digamma": "Ϝ",
    "dotplus": "∔",
    "epsilon": "∊",
    "gtrless": "≷",
    "implies": "⇒",
    "leadsto": "↝",
    "lessdot": "⋖",
    "lessgtr": "≶",
    "lesssim": "≲",
    "lozenge": "◊",
    "natural": "♮",
    "nearrow": "↗",
    "nexists": "∄",
    "nwarrow": "↖",
    "partial": "∂",
    "pilcrow": "¶",
    "precsim": "≾",
    "searrow": "↘",
    "section": "§",
    "succsim": "≿",
    "swarrow": "↙",
    "textbar": "|",
    "uparrow": "↑",
    "upsilon": "υ",
    "Bumpeq": "≎",
    "Lambda": "Λ",
    "Subset": "⋐",
    "Supset": "⋑",
    "Vvdash": "⊪",
    "approx": "≈",
    "bigcap": "⋂",
    "bigcup": "⋃",
    "bigvee": "⋁",
    "bowtie": "⋈",
    "boxdot": "⊡",
    "bullet": "∙",
    "bumpeq": "≏",
    "circeq": "≗",
    "coprod": "∐",
    "dagger": "†",
    "daleth": "ד",
    "degree": "°",
    "eqcirc": "≖",
    "exists": "∃",
    "forall": "∀",
    "gtrdot": "⋗",
    "gtrsim": "≳",
    "hslash": "ℏ",
    "lambda": "λ",
    "lfloor": "⌊",
    "ltimes": "⋉",
    "mapsto": "↦",
    "models": "⊨",
    "ominus": "⊖",
    "oslash": "⊘",
    "otimes": "⊗",
    "preceq": "⪯",
    "propto": "∝",
    "rfloor": "⌋",
    "rtimes": "⋊",
    "square": "□",
    "subset": "⊂",
    "succeq": "⪰",
    "supset": "⊃",
    "varphi": "φ",
    "varrho": "ϱ",
    "veebar": "⊻",
    "Delta": "Δ",
    "Gamma": "Γ",
    "Omega": "Ω",
    "Theta": "Θ",
    "Vdash": "⊩",
    "aleph": "ℵ",
    "Alpha": "Α",
    "alpha": "α",
    "angle": "∠",
    "asymp": "≍",
    "cdots": "⋯",
    "cents": "¢",
    "dashv": "⊣",
    "ddots": "⋱",
    "delta": "δ",
    "doteq": "≐",
    "equiv": "≡",
    "frown": "⌢",
    "gamma": "γ",
    "gimel": "ℷ",
    "infty": "∞",
    "kappa": "κ",
    "Kappa": "Κ",
    "lceil": "⌈",
    "nabla": "∇",
    "notin": "∉",
    "omega": "ω",
    "oplus": "⊕",
    "pound": "£",
    "prime": "′",
    "qquad": "  ",
    "rceil": "⌉",
    "sharp": "♯",
    "sigma": "σ",
    "simeq": "≃",
    "smile": "⌣",
    "space": "␣",
    "sqcap": "⊓",
    "sqcup": "⊔",
    "theta": "θ",
    "times": "×",
    "unlhd": "⊴",
    "unrhd": "⊵",
    "uplus": "⊎",
    "vDash": "⊨",
    "varpi": "ϖ",
    "vdash": "⊢",
    "vdots": "⋮",
    "wedge": "∧",
    "Finv": "Ⅎ",
    "Join": "⋈",
    "atop": "¦",
    "beta": "β",
    "Beta": "Β",
    "beth": "ב",
    "cdot": "⋅",
    "circ": "∘",
    "cong": "≅",
    "dots": "…",
    "euro": "€",
    "flat": "♭",
    "geqq": "≧",
    "hbar": "ℏ",
    "iota": "ι",
    "leqq": "≦",
    "odot": "⊙",
    "oint": "∮",
    "perp": "⊥",
    "prec": "≺",
    "prod": "∏",
    "quad": " ",
    "star": "⋆",
    "succ": "≻",
    "surd": "√",
    "zeta": "ζ",
    "Box": "□",
    "Cap": "⋒",
    "Cup": "⋓",
    "Lsh": "↰",
    "Phi": "Φ",
    "Psi": "Ψ",
    "Rsh": "↱",
    "ast": "∗",
    "bot": "⊥",
    "cap": "∩",
    "chi": "χ",
    "Chi": "Χ",
    "cup": "∪",
    "div": "÷",
    "ell": "ℓ",
    "eta": "η",
    "eth": "ð",
    "geq": "≥",
    "ggg": "⋙",
    "int": "∫",
    "leq": "≤",
    "lhd": "⊲",
    "lll": "⋘",
    "mho": "℧",
    "mid": "∣",
    "neg": "¬",
    "neq": "≠",
    "phi": "ϕ",
    "psi": "ψ",
    "rhd": "⊳",
    "rho": "ρ",
    "Rho": "Ρ",
    "sim": "∼",
    "sum": "∑",
    "tau": "τ",
    "Tau": "Τ",
    "top": "⊤",
    "vee": "∨",
    "Im": "ℑ",
    "Pi": "Π",
    "Re": "ℜ",
    "Xi": "Ξ",
    "ge": "≥",
    "gg": "≫",
    "in": "∈",
    "le": "≤",
    "ll": "≪",
    "mp": "∓",
    "mu": "μ",
    "Mu": "Μ",
    "ni": "∋",
    "nu": "ν",
    "Nu": "Ν",
    "pi": "π",
    "pm": "±",
    "wp": "℘",
    "wr": "≀",
    "xi": "ξ",
    "Omicron": "Ο",
    "omicron": "ο",
    "textdollar": "$",
    "textquotesingle": "'",
    "textbackslash": "\\",
    "textasciigrave": "`",
    "lbrace": "{",
    "vert": "|",
    "rbrace": "}",
    "textasciitilde": "~",
    "textexclamdown": "¡",
    "textcent": "¢",
    "textsterling": "£",
    "textcurrency": "¤",
    "textyen": "¥",
    "textbrokenbar": "¦",
    "textsection": "§",
    "textasciidieresis": "¨",
    "textcopyright": "©",
    "textordfeminine": "ª",
    "guillemotleft": "«",
    "lnot": "¬",
    "textasciimacron": "¯",
    "textdegree": "°",
    "textasciiacute": "´",
    "textparagraph": "¶",
    "textordmasculine": "º",
    "guillemotright": "»",
    "textonequarter": "¼",
    "textonehalf": "½",
    "textthreequarters": "¾",
    "textquestiondown": "¿",
    "AA": "Å",
    "AE": "Æ",
    "DH": "Ð",
    "texttimes": "×",
    "TH": "Þ",
    "ss": "ß",
    "aa": "å",
    "ae": "æ",
    "dh": "ð",
    "th": "þ",
    "DJ": "Đ",
    "dj": "đ",
    "Elzxh": "ħ",
    "i": "ı",
    "NG": "Ŋ",
    "ng": "ŋ",
    "OE": "Œ",
    "oe": "œ",
    "texthvlig": "ƕ",
    "textnrleg": "ƞ",
    "textdoublepipe": "ǂ",
    "Elztrna": "ɐ",
    "Elztrnsa": "ɒ",
    "Elzopeno": "ɔ",
    "Elzrtld": "ɖ",
    "Elzschwa": "ə",
    "Elzpgamma": "ɣ",
    "Elzpbgam": "ɤ",
    "Elztrnh": "ɥ",
    "Elzbtdl": "ɬ",
    "Elzrtll": "ɭ",
    "Elztrnm": "ɯ",
    "Elztrnmlr": "ɰ",
    "Elzltlmr": "ɱ",
    "Elzltln": "ɲ",
    "Elzrtln": "ɳ",
    "Elzclomeg": "ɷ",
    "textphi": "ɸ",
    "Elztrnr": "ɹ",
    "Elztrnrl": "ɺ",
    "Elzrttrnr": "ɻ",
    "Elzrl": "ɼ",
    "Elzrtlr": "ɽ",
    "Elzfhr": "ɾ",
    "Elzrtls": "ʂ",
    "Elzesh": "ʃ",
    "Elztrnt": "ʇ",
    "Elzrtlt": "ʈ",
    "Elzpupsil": "ʊ",
    "Elzpscrv": "ʋ",
    "Elzinvv": "ʌ",
    "Elzinvw": "ʍ",
    "Elztrny": "ʎ",
    "Elzrtlz": "ʐ",
    "Elzyogh": "ʒ",
    "Elzglst": "ʔ",
    "Elzreglst": "ʕ",
    "Elzinglst": "ʖ",
    "textturnk": "ʞ",
    "Elzdyogh": "ʤ",
    "Elztesh": "ʧ",
    "textasciicaron": "ˇ",
    "Elzverts": "ˈ",
    "Elzverti": "ˌ",
    "Elzlmrk": "ː",
    "Elzhlmrk": "ˑ",
    "Elzsbrhr": "˒",
    "Elzsblhr": "˓",
    "Elzrais": "˔",
    "Elzlow": "˕",
    "textasciibreve": "˘",
    "textperiodcentered": "˙",
    "texttildelow": "˜",
    "Epsilon": "Ε",
    "Zeta": "Ζ",
    "Eta": "Η",
    "Iota": "Ι",
    "Sigma": "Σ",
    "texttheta": "θ",
    "textvartheta": "ϑ",
    "Stigma": "Ϛ",
    "Digamma": "Ϝ",
    "Koppa": "Ϟ",
    "Sampi": "Ϡ",
    "textTheta": "ϴ",
    "textendash": "–",
    "textemdash": "—",
    "Vert": "‖",
    "Elzreapos": "‛",
    "textquotedblleft": "“",
    "textquotedblright": "”",
    "textdagger": "†",
    "textdaggerdbl": "‡",
    "textbullet": "•",
    "ldots": "…",
    "textperthousand": "‰",
    "textpertenthousand": "‱",
    "guilsinglleft": "‹",
    "guilsinglright": "›",
    "nolinebreak": "⁠",
    "Elzxrat": "℞",
    "nleftarrow": "↚",
    "nrightarrow": "↛",
    "arrowwaveleft": "↜",
    "arrowwaveright": "↝",
    "nleftrightarrow": "↮",
    "dblarrowupdown": "⇅",
    "nLeftarrow": "⇍",
    "nLeftrightarrow": "⇎",
    "nRightarrow": "⇏",
    "DownArrowUpArrow": "⇵",
    "rightangle": "∟",
    "nmid": "∤",
    "nparallel": "∦",
    "surfintegral": "∯",
    "volintegral": "∰",
    "clwintegral": "∱",
    "Colon": "∷",
    "homothetic": "∻",
    "lazysinv": "∾",
    "NotEqualTilde": "≂",
    "approxnotequal": "≆",
    "tildetrpl": "≋",
    "allequal": "≌",
    "NotHumpDownHump": "≎",
    "NotHumpEqual": "≏",
    "estimates": "≙",
    "starequal": "≛",
    "lneqq": "≨",
    "lvertneqq": "≨",
    "gneqq": "≩",
    "gvertneqq": "≩",
    "NotLessLess": "≪",
    "NotGreaterGreater": "≫",
    "lessequivlnt": "≲",
    "greaterequivlnt": "≳",
    "notlessgreater": "≸",
    "notgreaterless": "≹",
    "precapprox": "≾",
    "NotPrecedesTilde": "≾",
    "succapprox": "≿",
    "NotSucceedsTilde": "≿",
    "subsetneq": "⊊",
    "varsubsetneqq": "⊊",
    "supsetneq": "⊋",
    "varsupsetneq": "⊋",
    "NotSquareSubset": "⊏",
    "NotSquareSuperset": "⊐",
    "truestate": "⊧",
    "forcesextra": "⊨",
    "VDash": "⊫",
    "nvdash": "⊬",
    "nvDash": "⊭",
    "nVdash": "⊮",
    "nVDash": "⊯",
    "original": "⊶",
    "image": "⊷",
    "hermitconjmatrix": "⊹",
    "rightanglearc": "⊾",
    "backsimeq": "⋍",
    "verymuchless": "⋘",
    "verymuchgreater": "⋙",
    "Elzsqspne": "⋥",
    "lnsim": "⋦",
    "gnsim": "⋧",
    "precedesnotsimilar": "⋨",
    "succnsim": "⋩",
    "ntriangleleft": "⋪",
    "ntriangleright": "⋫",
    "ntrianglelefteq": "⋬",
    "ntrianglerighteq": "⋭",
    "upslopeellipsis": "⋰",
    "downslopeellipsis": "⋱",
    "perspcorrespond": "⌆",
    "recorder": "⌕",
    "ulcorner": "⌜",
    "urcorner": "⌝",
    "llcorner": "⌞",
    "lrcorner": "⌟",
    "langle": "〈",
    "rangle": "〉",
    "Elzdlcorn": "⎣",
    "lmoustache": "⎰",
    "rmoustache": "⎱",
    "textvisiblespace": "␣",
    "Elzdshfnc": "┆",
    "Elzsqfnw": "┙",
    "diagup": "╱",
    "Elzvrecto": "▯",
    "Elzcirfl": "◐",
    "Elzcirfr": "◑",
    "Elzcirfb": "◒",
    "Elzrvbull": "◘",
    "Elzsqfl": "◧",
    "Elzsqfr": "◨",
    "Elzsqfse": "◪",
    "bigcirc": "◯",
    "rightmoon": "☾",
    "mercury": "☿",
    "venus": "♀",
    "male": "♂",
    "jupiter": "♃",
    "saturn": "♄",
    "uranus": "♅",
    "neptune": "♆",
    "pluto": "♇",
    "aries": "♈",
    "taurus": "♉",
    "gemini": "♊",
    "cancer": "♋",
    "leo": "♌",
    "virgo": "♍",
    "libra": "♎",
    "scorpio": "♏",
    "sagittarius": "♐",
    "capricornus": "♑",
    "aquarius": "♒",
    "pisces": "♓",
    "quarternote": "♩",
    "eighthnote": "♪",
    "UpArrowBar": "⤒",
    "DownArrowBar": "⤓",
    "Elolarr": "⥀",
    "Elorarr": "⥁",
    "ElzRlarr": "⥂",
    "ElzrLarr": "⥄",
    "Elzrarrx": "⥇",
    "LeftRightVector": "⥎",
    "RightUpDownVector": "⥏",
    "DownLeftRightVector": "⥐",
    "LeftUpDownVector": "⥑",
    "LeftVectorBar": "⥒",
    "RightVectorBar": "⥓",
    "RightUpVectorBar": "⥔",
    "RightDownVectorBar": "⥕",
    "DownLeftVectorBar": "⥖",
    "DownRightVectorBar": "⥗",
    "LeftUpVectorBar": "⥘",
    "LeftDownVectorBar": "⥙",
    "LeftTeeVector": "⥚",
    "RightTeeVector": "⥛",
    "RightUpTeeVector": "⥜",
    "RightDownTeeVector": "⥝",
    "DownLeftTeeVector": "⥞",
    "DownRightTeeVector": "⥟",
    "LeftUpTeeVector": "⥠",
    "LeftDownTeeVector": "⥡",
    "UpEquilibrium": "⥮",
    "ReverseUpEquilibrium": "⥯",
    "RoundImplies": "⥰",
    "Elztfnc": "⦀",
    "Elroang": "⦆",
    "Elzddfnc": "⦙",
    "Angle": "⦜",
    "Elzlpargt": "⦠",
    "ElzLap": "⧊",
    "Elzdefas": "⧋",
    "LeftTriangleBar": "⧏",
    "NotLeftTriangleBar": "⧏",
    "RightTriangleBar": "⧐",
    "NotRightTriangleBar": "⧐",
    "RuleDelayed": "⧴",
    "Elxuplus": "⨄",
    "ElzThr": "⨅",
    "Elxsqcup": "⨆",
    "ElzInf": "⨇",
    "ElzSup": "⨈",
    "ElzCint": "⨍",
    "clockoint": "⨏",
    "sqrint": "⨖",
    "ElzTimes": "⨯",
    "amalg": "⨿",
    "ElzAnd": "⩓",
    "ElzOr": "⩔",
    "ElOr": "⩖",
    "Elzminhat": "⩟",
    "Equal": "⩵",
    "nleqslant": "⩽",
    "geqslant": "⩾",
    "ngeqslant": "⩾",
    "lessapprox": "⪅",
    "gtrapprox": "⪆",
    "lneq": "⪇",
    "gneq": "⪈",
    "lnapprox": "⪉",
    "gnapprox": "⪊",
    "lesseqqgtr": "⪋",
    "gtreqqless": "⪌",
    "eqslantless": "⪕",
    "eqslantgtr": "⪖",
    "NestedLessLess": "⪡",
    "NotNestedLessLess": "⪡",
    "NestedGreaterGreater": "⪢",
    "NotNestedGreaterGreater": "⪢",
    "precneqq": "⪵",
    "succneqq": "⪶",
    "precnapprox": "⪹",
    "succnapprox": "⪺",
    "subseteqq": "⫅",
    "nsubseteqq": "⫅",
    "supseteqq": "⫆",
    "subsetneqq": "⫋",
    "supsetneqq": "⫌",
    "Elztdcol": "⫶",
    "openbracketleft": "〚",
    "openbracketright": "〛",
    checkmark: "✓",
    maltese: "✠",
};
function isCharacterUnicode(x) {
    return exports.characterUnicodeChart.hasOwnProperty(x);
}
exports.isCharacterUnicode = isCharacterUnicode;
exports.characterUnicode = function (name) { return isCharacterUnicode(name) ? exports.characterUnicodeChart[name] : undefined; };
//# sourceMappingURL=symbols.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/unicode/commands/0args/symbols.js
// module id = 101
// module chunks = 0 1 2 3